import { Download, Copy } from "lucide-react";

const PNG_PRESETS = [16, 24, 32, 64, 128, 256, 512];

type ExportPanelProps = {
  title: string;
  svgLabel: string;
  pngLabel: string;
  copyLabel: string;
  presetsLabel: string;
  onExportSvg: () => void;
  onExportPng: () => void;
  onCopySvg: () => void;
  onExportPreset: (size: number) => void;
  disabled?: boolean;
};

export function ExportPanel({
  title,
  svgLabel,
  pngLabel,
  copyLabel,
  presetsLabel,
  onExportSvg,
  onExportPng,
  onCopySvg,
  onExportPreset,
  disabled = false,
}: ExportPanelProps) {
  return (
    <section className="flc-panel flc-export">
      <div className="flc-panel-header">
        <h2>{title}</h2>
      </div>
      <div className="flc-export-actions">
        <button
          type="button"
          className="flc-primary"
          onClick={onExportSvg}
          disabled={disabled}
        >
          <Download size={16} />
          {svgLabel}
        </button>
        <button
          type="button"
          className="flc-secondary"
          onClick={onExportPng}
          disabled={disabled}
        >
          <Download size={16} />
          {pngLabel}
        </button>
        <button
          type="button"
          className="flc-secondary"
          onClick={onCopySvg}
          disabled={disabled}
        >
          <Copy size={16} />
          {copyLabel}
        </button>
      </div>

      <div className="flc-export-presets">
        <div className="flc-label">{presetsLabel}</div>
        <div className="flc-preset-grid">
          {PNG_PRESETS.map((size) => (
            <button
              key={size}
              type="button"
              className="flc-chip"
              onClick={() => onExportPreset(size)}
              disabled={disabled}
            >
              {size}px
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
